import React from 'react';
import cn from 'classnames';
import { Button, Icon } from 'antd';
import styles from './ActionsCell.module.scss';

const hasFn = (fn) => typeof fn === 'function';

const ActionsCell = ({ record, onEditBtnClick, onDeleteBtnClick }) => {
  return (
    <div className={styles.root}>
      {hasFn(onEditBtnClick) && (
        <Button
          className={cn(styles.button, styles.editButton)}
          onClick={(e) => {
            e.stopPropagation();
            onEditBtnClick(record);
          }}
        >
          <Icon type="edit" theme="filled" />
        </Button>
      )}
      {hasFn(onDeleteBtnClick) && (
        <Button
          className={cn(styles.button, styles.deleteButton)}
          onClick={(e) => {
            e.stopPropagation();
            onDeleteBtnClick(record);
          }}
        >
          <Icon type="delete" theme="filled" />
        </Button>
      )}
    </div>
  );
};

export default ActionsCell;
